<script lang="ts" setup>
import { computed } from 'vue';
import useMarkdown from '@/hooks/markdown';
import { $fetch } from '@/plugins/fetch';
import { useAsyncData } from '@/hooks/async-data';
import { useAppStore } from '@/stores/app';
import { useRouter } from 'vue-router';

const {
  slug,
} = defineProps<{
  slug: string;
}>();

const router = useRouter();
const appStore = useAppStore();
const marked = useMarkdown();

interface TranslationArticle {
  id: string;
  title: string;
  content: string;
  url: string;
}

const { data: listing } = useAsyncData<TranslationArticle[]>(
  'law:translation:apache',
  () => $fetch('/law/resource/v1/list', {
    data: {
      category: import.meta.env.VITE_LAW_TRANSLATION_CATEGORY_ID5,
      limit: -1,
    },
  }),
  {
    onAfterHandle({ handleSuccess, serverContext }) {
      const article = listing.value?.find(item => item.url === slug);

      if (serverContext) {
        if (handleSuccess && article) {
          serverContext.title = article.title;
        }
        else {
          // 请求出错或未匹配到文章，服务器重定向到 404 页面
          serverContext.redirect = '/404';
        }
      }
      else {
        if (handleSuccess && article) {
          appStore.setTitle(article.title);
        }
        else {
          router.replace('/404');
        }
      }
    },
  },
);

const currentArticle = computed(() => listing.value?.find(item => item.url === slug) ?? null);

const markedContent = computed(() => (currentArticle.value?.content ? marked.parse(currentArticle.value.content) : ''));
</script>

<template>
  <main class="page-law-article relative mt-48px <md:mt-32px">
    <img class="absolute left-0 top-0 translate-[-45%,-55%] -z-1 <md:hidden" src="@/assets/journalism/circle.svg" alt="">

    <div class="mx-auto min-h-1000px w-1360px <2xl:w-1200px <xl:w-full <xl:px-24 <sm:px-16">
      <header v-if="currentArticle?.title" class="<md:mt-48px> mx-auto mt-96px w-full text-center">
        <h1 class="<md:leading-40px> m-0 text-balance text-40px color-hex-2d2d2d font-medium leading-60px <md:text-28px">
          {{ currentArticle.title }}
        </h1>
      </header>

      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="news-details-content mx-auto mt-96px w-960px pb-80px color-hex-2d2d2d <md:mt-48px <md:w-full <md:pb-48px" v-html="markedContent"></div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.news-details-content {
  box-sizing: border-box;
  overflow-wrap: break-word;

  &:deep() {
    h1,
    h2 {
      margin-top: 48px;
    }

    p,
    section {
      margin-top: 1em;
      margin-bottom: 1em;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

    img {
      max-width: 100%;
      object-fit: contain;
    }

    a {
      color: #1180ff;
      text-decoration: none;
    }
  }
}
</style>
